<template>
  <el-dialog
    title="扫码签名"
    :visible.sync="signDialogVisible"
    width="520px"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :z-index="4100"
    append-to-body
    @close="handleCloseSignDialog"
  >
    <div class="sign-dialog">
      <div class="sign-history" v-if="historySign">
        <div class="label">历史签名：</div>
        <div class="history-box">
          <img :src="historySign" alt="历史签名" />
          <!-- <div v-else class="history-empty">暂无历史签名</div> -->
        </div>
        <el-button type="primary" size="mini" @click="handleUseHistory">
          使用此签名
        </el-button>
      </div>
      <div class="sign-qrcode">
        <div class="label">{{ historySign ? '重新签名' : '签名' }}：</div>
        <div class="qr-box">
          <vue-qr :text="qrUrl" :margin="0" :size="200" />
        </div>
        <el-button type="primary" size="mini" @click="handleConfirmSign">完成签名</el-button>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import vueQr from "vue-qr";

export default {
  name: "PledgeDialog",
  components: {
    vueQr,
  },
  data() {
    return {
      signDialogVisible: false,
      qrUrl: "",
      historySign: "",
      selectedSign: "",
    };
  },
  computed: {
    dateObj() {
      return this.pledgeData.date ? new Date(this.pledgeData.date) : new Date();
    },
    displayYear() {
      return this.dateObj.getFullYear();
    },
    displayMonth() {
      return this.dateObj.getMonth() + 1;
    },
    displayDay() {
      return this.dateObj.getDate();
    },
  },
  methods: {
    open() {
      this.buildSignDialog();
      this.signDialogVisible = true;
      this.$http.get('/student/signature/my/history').then((res) => {
        if (res && res.length > 0) {
          this.historySign = res[0].signatureImg
        }
        
      }).catch(() => {
      });
    },
    buildSignDialog() {
      const user = (this.$store && this.$store.state && this.$store.state.user) || {};
      const params = new URLSearchParams();
      const userId = user.userId || user.id || user.uid || "";
      if (userId) params.append("userId", userId);
      params.append("type", "thesisPledge");
      // const base = `${location.origin}${location.pathname}#/sign`;
      const base = `${location.origin}/student-sign`;
      this.qrUrl = `${base}?${params.toString()}`;
    },
    handleUseHistory() {
      this.$emit("sign-success", this.historySign);
      this.signDialogVisible = false;
    },
    handleConfirmSign() {
      this.$http.get('/student/signature/my/history').then((res) => {
        if (res && res.length > 0) {
          this.selectedSign = res[0].signatureImg
          this.$emit("sign-success", this.selectedSign);
          this.signDialogVisible = false;
        } else {
          this.$message.error('未获取到个人签名')
          return
        }
        
      }).catch(() => {
        // alert('提交失败');
      });
      return
    },
    handleCloseSignDialog() {
      this.signDialogVisible = false;
    },
  },
};
</script>

<style scoped lang="scss">
.pledge-dialog ::v-deep .el-dialog__header {
  display: none;
}
.pledge-container {
  padding: 10px 16px 6px;
  color: #222;
}
.pledge-title {
  text-align: center;
  font-weight: 700;
  font-size: 22px;
  letter-spacing: 1px;
  margin-bottom: 10px;
}
.pledge-sheet {
  border: 1px solid #333;
  padding: 12px;
  box-shadow: 0 2px 6px rgba(0, 0, 0, 0.08);
}
.pledge-table {
  width: 100%;
  border-collapse: collapse;
  margin-bottom: 14px;
  font-size: 14px;
}
.pledge-table th,
.pledge-table td {
  border: 1px solid #333;
  padding: 10px 12px;
  text-align: left;
}
.pledge-table th {
  width: 120px;
  background: #f8f8f8;
}
.pledge-body {
  border: 1px solid #333;
  padding: 18px 16px 12px;
}
.pledge-body__title {
  text-align: center;
  font-weight: 700;
  font-size: 18px;
  margin-bottom: 10px;
}
.pledge-body p {
  line-height: 1.8;
  text-indent: 2em;
  margin-bottom: 18px;
}
.pledge-sign {
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  justify-content: center;
  .sign-thumb {
    height: 40px;
    margin-left: 12px;
    // border: 1px solid #eee;
    padding: 4px;
    // background: #fff;
    cursor: pointer;
  }
}
.pledge-date {
  display: flex;
  gap: 6px;
  justify-content: flex-end;
}
.sign-dialog {
  display: flex;
  justify-content: space-between;
  gap: 16px;
}
.sign-history,
.sign-qrcode {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 12px;
}
.label {
  font-weight: 600;
  align-self: flex-start;
}
.history-box,
.qr-box {
  border: 1px solid #e5e5e5;
  padding: 10px;
  min-height: 120px;
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  background: #fafafa;
}
.history-box img {
  max-width: 100%;
  max-height: 120px;
}
.history-empty {
  color: #999;
}
.pledge-actions {
  text-align: center;
  margin-top: 16px;
}
</style>

